import { IProductOption } from "@faire/web-api/indigofair/data/IProductOption";
import { IProductPageResponse } from "@faire/web-api/indigofair/data/IProductPageResponse";
import React from "react";
import styled from "styled-components";

import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer/lib/isLoggedInRetailer";

import { ProductAddToCartState } from "../AddToCart/ProductAddToCartState";

import { LowStockText } from "./LowStockText";
import { SKUsText } from "./SKUsText";

export const VariantLevelInfo: React.FunctionComponent<
  VariantLevelInfo.IProps
> = ({
  product,
  selectedOption,
  productAddToCartState,
  actionWhenSKUVisible,
}) => {
  return (
    <Wrapper>
      <SKUsText
        product={product}
        selectedOption={selectedOption}
        productAddToCartState={productAddToCartState}
        actionWhenVisible={actionWhenSKUVisible}
      />
      {isLoggedInRetailerOrBrandPreview() ? (
        <LowStockText product={product} selectedOption={selectedOption} />
      ) : null}
    </Wrapper>
  );
};

namespace VariantLevelInfo {
  export interface IProps {
    product: IProductPageResponse.IPdpProduct;
    selectedOption?: IProductOption;
    productAddToCartState: ProductAddToCartState;
    actionWhenSKUVisible: () => void;
  }
}

const Wrapper = styled.div`
  margin-bottom: 24px;
  &:empty {
    margin-bottom: 0px;
  }
`;
